import FRANTIESCO_EXT_1 from "./FRANTIESCO_EXT_1";
export default {
  FRANTIESCO_EXT_1,
};
